<p class="info-text px-4 py-8">
  Velg ladepunktet så nøyaktig som mulig, innenfor 200 meter fra der bilen vil
  stå. Om du ikke får noen resultater via søket kan du velge en lokasjon direkte
  i kartet
</p>
<div class="mapContainer">
  <input
    class="placeSearch"
    #placeSearch
    placeholder="Søk etter adresse"
    [class.input-width]="shrinkInput"
  />
  <app-map
    [locationSuggestions]="locationSuggestions"
    [autoCompleteSuggestions]="autoCompleteSuggestions"
    (emitSelectedLocation)="setSelectedLocation($event)"
  >
  </app-map>
  <div *ngIf="selectedLocation">
    <p class="m-0 mt-2">Du har valgt:</p>
    <p>
      <strong>{{
        selectedLocation?.formatted_address.split(',')[0] ??
          selectedLocation?.formatted_address
      }}</strong>
    </p>
  </div>
  <div class="button-container mt-4">
    <ion-button [class.mt-2]="!selectedLocation" (click)="back()"
      >Tilbake</ion-button
    >
    <ion-button *ngIf="selectedLocation" class="green" (click)="submit()"
      >Bruk denne adressen</ion-button
    >
  </div>
</div>
